import { Inject, Component } from '@angular/core';
import { environment } from '@environment/environment';
import { OktaAuth} from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { Observable, from, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  loginLink = `${environment.memberPortalUrl}/login`;
  public navbarOpen = false;
  public $authenticated: Observable<boolean>;

  constructor(@Inject(OKTA_AUTH) private oktaAuthService: OktaAuth) {
    this.$authenticated = of(false)
      .pipe(
        delay(500),
        switchMap(() => from(this.oktaAuthService.isAuthenticated())),
      );
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logout() {
    this.oktaAuthService.tokenManager.remove('accessToken');
    this.oktaAuthService.tokenManager.remove('idToken');
    this.oktaAuthService.signOut({
      postLogoutRedirectUri: `${window.location.origin}/session-expired`,

    });
  }

}
